export default __webpack_public_path__ + "static/media/apple-touch-icon.374048d5.png";